import {Component, Input, EventEmitter, Output, ViewChild, OnInit} from '@angular/core';
import { Editor } from 'primeng/primeng';
import { Quill } from 'quill';

@Component({
    selector: 'jhi-information-component',
    templateUrl: 'information.component.html'
})
export class InformationComponent implements OnInit {

    @Input() information: String;

    @ViewChild(Editor)
    editor: Editor;

    constructor() {
    }

    ngOnInit() {
        // let quill = new Quill('#editor');
        // quill.enable(false);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/blocks/information/information.component.ts